/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * One shipment on the lane, from this carrier's side.
 *
 * Carries their own rank but never a premium or a price. The lane average
 * premium is an accepted disclosure; a per-shipment one is not — on a thin
 * lane, a carrier who knows their own rate could read the winner's exact
 * price straight off it.
 *
 * @export
 * @interface PerformanceLaneShipment
 */
export interface PerformanceLaneShipment {
  /**
   *
   * @type {string}
   * @memberof PerformanceLaneShipment
   */
  quotedAt: string;
  /**
   *
   * @type {boolean}
   * @memberof PerformanceLaneShipment
   */
  won: boolean;
  /**
   * 1 = cheapest on the board the customer saw.
   * @type {number}
   * @memberof PerformanceLaneShipment
   */
  priceRank?: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceLaneShipment
   */
  carriersQuoting?: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceLaneShipment
   */
  weightPounds?: number;
  /**
   *
   * @type {string}
   * @memberof PerformanceLaneShipment
   */
  freightClass?: string;
  /**
   *
   * @type {string}
   * @memberof PerformanceLaneShipment
   */
  service?: string;
  /**
   * Present only on shipments this carrier was booked on.
   * @type {number}
   * @memberof PerformanceLaneShipment
   */
  spend?: number;
}

/**
 * Check if a given object implements the PerformanceLaneShipment interface.
 */
export function instanceOfPerformanceLaneShipment(
  value: object,
): value is PerformanceLaneShipment {
  if (!("quotedAt" in value) || value["quotedAt"] === undefined) return false;
  if (!("won" in value) || value["won"] === undefined) return false;
  return true;
}

export function PerformanceLaneShipmentFromJSON(
  json: any,
): PerformanceLaneShipment {
  return PerformanceLaneShipmentFromJSONTyped(json, false);
}

export function PerformanceLaneShipmentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerformanceLaneShipment {
  if (json == null) {
    return json;
  }
  return {
    quotedAt: json["quotedAt"],
    won: json["won"],
    priceRank: json["priceRank"] == null ? undefined : json["priceRank"],
    carriersQuoting:
      json["carriersQuoting"] == null ? undefined : json["carriersQuoting"],
    weightPounds:
      json["weightPounds"] == null ? undefined : json["weightPounds"],
    freightClass:
      json["freightClass"] == null ? undefined : json["freightClass"],
    service: json["service"] == null ? undefined : json["service"],
    spend: json["spend"] == null ? undefined : json["spend"],
  };
}

export function PerformanceLaneShipmentToJSON(
  json: any,
): PerformanceLaneShipment {
  return PerformanceLaneShipmentToJSONTyped(json, false);
}

export function PerformanceLaneShipmentToJSONTyped(
  value?: PerformanceLaneShipment | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    quotedAt: value["quotedAt"],
    won: value["won"],
    priceRank: value["priceRank"],
    carriersQuoting: value["carriersQuoting"],
    weightPounds: value["weightPounds"],
    freightClass: value["freightClass"],
    service: value["service"],
    spend: value["spend"],
  };
}
